// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const GoogleRecaptchaWrapper = registerClientReference(
    function() { throw new Error("Attempted to call GoogleRecaptchaWrapper() from the server but GoogleRecaptchaWrapper is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/hooks/google-recaptcha-wrapper.tsx",
    "GoogleRecaptchaWrapper",
);
